import { styled } from '@mui/material/styles'

export const StyledPDFViewer = styled('embed')(() => ({
  width: 800,
  height: 1020,
}))

export const StyledImgViewer = styled('img')(() => ({
  width: 800,
  height: 'auto',
}))
